import { researchSummary } from "@highmarch/app";
import { openResearch } from "../ui/research/researchSheet";
import type { Feature } from "./registry";

/** The Guide topic is open once Tribute and builders are (the first clears): research needs a tower at level 2. */
const TOPIC_FROM_LEVEL = 2;

/**
 * Gold Research (M35, docs/RESEARCH.md): the Guide topic, and debug hooks for captures and smokes. The tree screen is
 * ui/research/researchSheet.ts (`openResearch`), reached from each tower's upgrade sheet and the Shop's Gold page; its
 * save section and rules are @highmarch/app research.ts and @highmarch/domain meta/research.ts; Bram's lines are
 * ui/guide/scripts/research.ts.
 */
export const researchFeature: Feature = {
  id: "research",
  register(ctx, registry) {
    registry.guideTopic({
      id: "research", group: "castle", label: "Research", art: { icon: "star" }, fromLevel: TOPIC_FROM_LEVEL, steps: [],
      lines: [
        "**Research** buys a tower permanent perks with gold: more damage, range or points. Find it on each tower's sheet in **Towers**.",
        "Each tree has five nodes. A node opens at a **tower level** and once the one above it is researched.",
        "The **Fortress** has a tree too: more health, tougher troops and sharper shots.",
      ],
    });
    if (ctx.debug && typeof window !== "undefined") {
      (window as unknown as { __tdResearch: unknown }).__tdResearch = {
        open: (towerId?: string) => openResearch(ctx.ui, towerId),
        summary: () => researchSummary(ctx.catalog.profile),
      };
    }
  },
};
